export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8616.3171ef51.jpg";